import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { addLand } from '../../../network/apis';

export const addLandRequest = createAsyncThunk('form/addLand', async (formData, thunkAPI) => {
  try {
    const response = await addLand(formData);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

const initialState = {
  formData: {},
  currentStep: 0,
  loading: false, // Track loading state
  error: null, // Track error state
};

const formSlice = createSlice({
  name: 'landpieceForm',
  initialState,
  reducers: {
    updateFormData: (state, action) => {
      state.formData = { ...state.formData, ...action.payload };
    },
    resetFormData: (state) => {
      state.formData = initialState.formData;
    },
    setFormErrors: (state, action) => {
      state.error = action.payload;
    },
    clearFormErrors: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addLandRequest.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addLandRequest.fulfilled, (state, action) => {
        state.loading = false;
        // Handle successful form submission (e.g., reset form state or navigate away)
      })
      .addCase(addLandRequest.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { updateFormData, nextStep, prevStep, resetFormData, setFormErrors, clearFormErrors } = formSlice.actions;

export default formSlice.reducer;
